module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("5 Minutes With Jesus: Quiet Time for Your Soul")]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AIa"
    }
  }, [_c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pA5e"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "id": "A5e",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pz6-2"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/contents#ba_03",
      "id": "ab_03"
    }
  }, [_vm._v("As a Mother Comforts Her Child")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pARj"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("t seemed to sneak up on me overnight. One moment Christian was a little boy who needed his mom for so much, and the next he was off to college—independent, confident, and strong.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-5"
    }
  }, [_vm._v("One morning I sat in my favorite chair with a cup of tea, looking through old family photo albums and remembering some of my favorite moments from his childhood. There was the Alaska trip when Christian was nine years old. Part of our trip package included dogsledding. The chief “musher” asked Christian if he would like to direct the sled. When Christian looked at me, I said, “Go for it! You can do it. If you fall, I’ll be right there.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz6-6"
    }
  }, [_vm._v("I must have said that a hundred times as he was growing up: “If you fall, I’ll be right there!” Now I say a variation of it in my prayers for him, thanking God that if Christian falls, his heavenly Father will be right there.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-1"
    }
  }, [_vm._v("We can find great comfort in thinking of God as our Father. But did you know that when God wanted to describe how He comforts His children, God compared Himself to a mother?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-2"
    }
  }, [_vm._v("In the book of Isaiah, God had some difficult things to say to His children, the Israelites. Despite His loving care of them, they had stubbornly rejected Him over and over again. He had sent His messengers, the prophets, to call His children back to Him, but they didn’t listen. Finally, the time came when the Lord decided to let His children have their own way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-3"
    }
  }, [_vm._v("But the Israelites had forgotten something important: the same God they were rejecting was the One protecting them. He warned the Israelites that when He removed His protection, their enemies would sweep in and take them into captivity. It was terrifying, heartbreaking news—and God knew it. He couldn’t bear to deliver it without comforting His children, and when He did, He used this imagery: “As a mother comforts her child, so will I comfort you” (Isaiah 66:13).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-4"
    }
  }, [_vm._v("One of the most precious blessings of taking time to replenish our souls in God’s presence is the tender comfort He offers us when we are hurting. It is so easy to run to a thousand other places when our hearts are wounded, but our compassionate God wants us to come to Him"), _c('i', [_vm._v(".")]), _vm._v(" He wants us to trust Him with our wounded hearts.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz7-5"
    }
  }, [_vm._v("Will you allow Him to comfort you today?")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('i', [_c('b', [_vm._v("If you fall, He’ll be right there!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2",
    attrs: {
      "id": "pz8-2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-8-1.jpg",
      "id": "Afm",
      "src": "images/himg-8-1.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Five Minutes in the Word")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images/himg-8-2.jpg",
      "id": "Afu",
      "src": "images/himg-8-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz8-3"
    }
  }, [_c('i', [_vm._v("Comfort, comfort my people, says your God.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz8-4"
    }
  }, [_vm._v("Isaiah 40:1")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz8-5"
    }
  }, [_c('i', [_vm._v("You who bring good news to Jerusalem, lift up your voice with a shout, lift it up, do not be afraid; say to the towns of Judah, “Here is your God!”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz8-6"
    }
  }, [_vm._v("Isaiah 40:9")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz8-7"
    }
  }, [_c('i', [_vm._v("He tends his flock like a shepherd: He gathers the lambs in his arms and carries them close to his heart; he gently leads those that have young.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz8-8"
    }
  }, [_vm._v("Isaiah 40:11")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz8-9"
    }
  }, [_c('i', [_vm._v("Why do you complain, Jacob? Why do you say, Israel, “My way is hidden from the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("; my cause is disregarded by my God”? Do you not know? Have you not heard? The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" is the everlasting God, the Creator of the ends of the earth. He will not grow tired or weary, and his understanding no one can fathom.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz8-14"
    }
  }, [_vm._v("Isaiah 40:27–28")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('i', [_vm._v("He gives strength to the weary and "), _c('span', {
    attrs: {
      "id": "pz10-1"
    }
  }, [_vm._v("increases")]), _vm._v(" the power of the weak. Even youths grow tired and weary, and young men stumble and fall; but those who hope in the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will "), _c('span', {
    attrs: {
      "id": "pz8-1"
    }
  }, [_vm._v("renew")]), _vm._v(" their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz9-5"
    }
  }, [_vm._v("Isaiah 40:29–31")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7e4146e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 72
// module chunks = 0